import { RouteConfig } from 'vue-router'
import { notificationsRouteNames } from '@/routes/constants/location'

const NotificationsPage = () =>
  import(
    /* webpackChunkName: "notifications" */ '@/pmd/pages/NotificationsPage.vue'
  ).then(m => m.default)

const NotificationsList = () =>
  import(
    /* webpackChunkName: "notification-list" */ '@/pmd/pages/NotificationsList.vue'
  ).then(m => m.default)

export const notificationsRoute: RouteConfig[] = [
    {
      path: 'notifications/:notification_id?',
      name: notificationsRouteNames.default,
      component: NotificationsPage,
    },
    {
      path: 'notificationslist',
      name: notificationsRouteNames.list,
      component: NotificationsList,
    },
]


